var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_t { 0% { transform: translate(20px,20px) rotate(0deg); } 100% { transform: translate(20px,20px) rotate(360deg); } }\n@keyframes a0_da { 0% { stroke-dasharray: 50px; } 100% { stroke-dasharray: 50px; } }\n@keyframes a0_do { 0% { stroke-dashoffset: 0px; } 100% { stroke-dashoffset: -100px; } }\n")), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10,
    ry: 10,
    fill: "none",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 50,
    transform: "translate(20,20)",
    style: {
      animation: "3s linear infinite both a0_t, 3s linear infinite both a0_da, 3s linear infinite both a0_do"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.5f33a1afc998936fd3db39d2140903b1.svg";
export { ForwardRef as ReactComponent };